import axios from 'axios/dist/axios';


const defaultState = {
    patientProfileData: {},
    startQuestionsData: [],
    generalQuestionsData: [],
    mustShowFullQuestion: '',
    assessmentToken: '',

    footerBtnNext: {
        isEnabled: false
    },
    patientProfileStatus: true,
    backFromGeneral: false
};

// ======================================================================
// Initial State
// ======================================================================

const state = {
    patientProfileData:     defaultState.patientProfileData,
    startQuestionsData:     defaultState.startQuestionsData,
    generalQuestionsData:   defaultState.generalQuestionsData,
    mustShowFullQuestion:   defaultState.mustShowFullQuestion,
    assessmentToken:        defaultState.assessmentToken,

    footerBtnNext: {
        isEnabled:          defaultState.footerBtnNext.isEnabled
    },
    patientProfileStatus:   defaultState.patientProfileStatus,
    backFromGeneral:        defaultState.backFromGeneral
};


// ======================================================================
// Getters
// ======================================================================

const getters = {
    getPatientProfileData: state => state.patientProfileData,

    getStartQuestionsData: state => state.startQuestionsData,
    getStartQuestionsAnswerList (state) {

        if (typeof state.startQuestionsData.questions === "undefined") {
            return [];
        }

        let answeredStartQuestions = state.startQuestionsData.questions.filter((startQuestion) => {
            return (startQuestion.providedAnswer !== null) ? true : false;
        });

        let startQuestionsAnswers = answeredStartQuestions.map((question) => {
            let providedAnswerCode = question.providedAnswer;
            let providedAnswerObj = question.answers.filter((crtAnswer) => {
                return (crtAnswer.code === providedAnswerCode) ? true : false;
            })[0];

            return providedAnswerObj.text;
        });

        return startQuestionsAnswers;
    },

    getGeneralQuestionsData: state => state.generalQuestionsData,
    getMustShowFullQuestion: state => state.mustShowFullQuestion,
    getAssessmentToken: state => state.assessmentToken,

    getStartQuestionList (state) {
        return (typeof state.startQuestionsData.questions !== 'undefined')
            ? state.startQuestionsData.questions
            : [];
    },

    getGeneralQuestionList (state) {
        return (typeof state.generalQuestionsData.questions !== 'undefined')
            ? state.generalQuestionsData.questions
            : [];
    },

    getIsFooterNextBtnEnabled (state) {
        return (state.footerBtnNext.isEnabled) ? true : false;
    },
    getStartQuestion (state) {
        return (typeof state.startQuestionsData !== 'undefined')
            ? state.startQuestionsData
            : [];
    },

    getGeneralQuestion (state) {
        return (typeof state.generalQuestionsData !== 'undefined')
            ? state.generalQuestionsData
            : [];
    },
    getPatientProfileStatus: state => state.patientProfileStatus,
    getBackFromGeneral: state => state.backFromGeneral

};


// ======================================================================
// Actions
// ======================================================================

const actions = {

    loadAssessmentStartData ({ dispatch, commit, rootGetters, getters }) {
        let promise = new Promise((resolve, reject) => {
            let productCode = rootGetters['PfProductListStore/getSelectedProductCode'];
            let requestParams = {};
            if (productCode !== null) {
                requestParams = {
                    productCode: productCode
                };
            }

            // Set assessmentData fields
            let assessmentData = {};

            const assessmentToken = rootGetters['SubmittedValuesStore/getAssessmentToken'];
            if (assessmentToken != null){
                assessmentData.assessmentToken = assessmentToken;
            }

            // get the patientId if there is any
            const pid = rootGetters['SubmittedValuesStore/getPid'];
            if (pid != null) {
                assessmentData.pid = pid;
            }

            if (Object.keys(assessmentData).length > 0) {
                requestParams.assessmentData = assessmentData;
            }

            // Set medData fields
            let medData = {};

            // get the date of birth if one was sent by the auto-login mechanism
            const dob = rootGetters['SubmittedValuesStore/getDob'];
            if (dob != null) {
                medData.birthdate = dob;
            }

            let sex = rootGetters['SubmittedValuesStore/getSex'];
            if (sex !== null){
                if (sex === 'm'){
                    sex = "male";
                }
                if (sex === 'f'){
                    sex = "female";
                }
            }

            if (sex != null) {
                medData.sex = sex;
            }

            if (Object.keys(medData).length > 0) {
                requestParams.medData = medData;
            }


            // let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/startAssessment', requestParams);
           // let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/startAssessment');
            let axiosRequest;
            if (state.backFromGeneral === true) {
                axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/startAssessment');
            } else {
                axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/startAssessment', requestParams);
            }

            axiosRequest.then((response) => {
                commit('setStartQuestionsData', response.data.data.START_QUESTIONS);
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {

                    if (typeof response.data.data !== "undefined" && typeof response.data.data.APP_PROPERTIES !== "undefined" && typeof response.data.data.APP_PROPERTIES.appProperties !== "undefined") {
                        commit("TranslationStore/setAppProperties", response.data.data.APP_PROPERTIES.appProperties, {root: true});
                        dispatch("SymptomsQuestionsStore/updateAssessmentTypeByAppProp", null, {root: true});
                    }

                    dispatch("updateAssessmentStartData", response.data);

                    resolve(response);
                } else {
                    reject(response);
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });

        });

        return promise;

    },

    loadAssessmentStartDataWithBack({ dispatch, commit, rootGetters, getters }) {
        let promise = new Promise((resolve, reject) => {

            let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/startAssessment');

            axiosRequest.then((response) => {

                if (typeof response.data.data !== "undefined" && typeof response.data.data.APP_PROPERTIES !== "undefined" && typeof response.data.data.APP_PROPERTIES.appProperties !== "undefined") {
                    commit("TranslationStore/setAppProperties", response.data.data.APP_PROPERTIES.appProperties, {root: true});
                    dispatch("SymptomsQuestionsStore/updateAssessmentTypeByAppProp", null, {root: true});
                }

                commit('setStartQuestionsData', response.data.data.START_QUESTIONS);
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                    dispatch("updateAssessmentStartData", response.data);

                    resolve(response);
                } else {
                    reject(response);
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });

        });

        return promise;

    },

    loadAssessmentTestData ({ dispatch, rootGetters }) {
        let promise = new Promise((resolve, reject) => {

            let productCode = rootGetters['ProductListStore/getSelectedProductCode'];
            let requestParams = {};
            if (productCode !== null) {
                requestParams = {
                    productCode: productCode
                };
            }

            let axiosRequest = axios.post(process.env.API_BASE_URL + '/test/createTestAssessment', requestParams);
            axiosRequest.then((response) => {
                if (typeof response.data.returnCode !== "undefined" && response.data.returnCode === 0) {
                    dispatch("updateAssessmentStartData", response.data);

                    resolve(response);
                } else {
                    reject(response);
                }
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    updateAssessmentStartData ({commit, dispatch}, axiosResponseData) {
        commit("clearPatientProfileData");
        commit("clearGeneralQuestionsData");

        if (typeof axiosResponseData.data !== "undefined") {

            if (typeof axiosResponseData.data.PRODUCT_TEXTS !== "undefined" && typeof axiosResponseData.data.PRODUCT_TEXTS.productTextMap !== "undefined") {
                dispatch('TranslationStore/appendProductRelatedTranslationData', axiosResponseData.data.PRODUCT_TEXTS.productTextMap, { root: true });
            }

            if (typeof axiosResponseData.data.PATIENT_DATA !== "undefined") {
                commit('setPatientProfileData', axiosResponseData.data.PATIENT_DATA);
            }

            if (typeof axiosResponseData.data.GENERAL_QUESTIONS !== "undefined") {
                commit('setGeneralQuestionsData', axiosResponseData.data.GENERAL_QUESTIONS);
            }

            if (typeof axiosResponseData.data.START_QUESTIONS !== "undefined") {
                commit('setStartQuestionsData', axiosResponseData.data.START_QUESTIONS);
            }

            if (typeof axiosResponseData.assessment !== "undefined") {
                commit('setAssessmentToken', axiosResponseData.assessment.assessmentToken);
            }

            if (typeof axiosResponseData.data.START_QUESTIONS !== "undefined"
                && typeof axiosResponseData.data.START_QUESTIONS.countAnswered !== "undefined"
                && typeof axiosResponseData.data.START_QUESTIONS.countTotal !== "undefined"
                && axiosResponseData.data.START_QUESTIONS.countAnswered === axiosResponseData.data.START_QUESTIONS.countTotal) {
                commit("enableFooterBtnNext");
            }
            else {
                commit("disableFooterBtnNext");
            }

            dispatch("AssessmentAlertsStore/refreshAlerts", axiosResponseData, { root: true });
        }

        commit("ProductListStore/clearSelectedProductCode", {}, {root: true});
    },

    updateAssessmentStartQuestionsData ({commit, dispatch}, axiosResponseData) {
        commit("clearStartQuestionsData");
        if (typeof axiosResponseData.data !== "undefined") {

            if (typeof axiosResponseData.data.START_QUESTIONS !== "undefined") {
                commit('setStartQuestionsData', axiosResponseData.data.START_QUESTIONS);
            }

            if (typeof axiosResponseData.assessment !== "undefined") {
                commit('setAssessmentToken', axiosResponseData.assessment.assessmentToken);
            }

            let areAllStartQuestionsAnswered = (typeof axiosResponseData.data.START_QUESTIONS !== "undefined"
                && typeof axiosResponseData.data.START_QUESTIONS.countAnswered !== "undefined"
                && typeof axiosResponseData.data.START_QUESTIONS.countTotal !== "undefined"
                && axiosResponseData.data.START_QUESTIONS.countAnswered === axiosResponseData.data.START_QUESTIONS.countTotal) ? true : false;
            if (areAllStartQuestionsAnswered) {
                commit("enableFooterBtnNext");
            }   else {
                commit("disableFooterBtnNext");
            }

            dispatch("AssessmentAlertsStore/refreshAlerts", axiosResponseData, { root: true });
        }
    },
    updateAssessmentGeneralQuestionsData ({commit, dispatch}, axiosResponseData) {
        commit("clearStartQuestionsData");
        commit("clearGeneralQuestionsData");
        if (typeof axiosResponseData.data !== "undefined") {

            if (typeof axiosResponseData.data.GENERAL_QUESTIONS !== "undefined") {
                commit('setGeneralQuestionsData', axiosResponseData.data.GENERAL_QUESTIONS);
            }

            if (typeof axiosResponseData.assessment !== "undefined") {
                commit('setAssessmentToken', axiosResponseData.assessment.assessmentToken);
            }

            let areAllGeneralQuestionsAnswered = (typeof axiosResponseData.data.GENERAL_QUESTIONS !== "undefined"
                && typeof axiosResponseData.data.GENERAL_QUESTIONS.countAnswered !== "undefined"
                && typeof axiosResponseData.data.GENERAL_QUESTIONS.countTotal !== "undefined"
                && axiosResponseData.data.GENERAL_QUESTIONS.countAnswered === axiosResponseData.data.GENERAL_QUESTIONS.countTotal) ? true : false;

            if (areAllGeneralQuestionsAnswered ) {
                commit("enableFooterBtnNext");
            }            else {
                commit("disableFooterBtnNext");
            }

            dispatch("AssessmentAlertsStore/refreshAlerts", axiosResponseData, { root: true });
        }
    },


    loadAssessmentGeneralData ({ commit }) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/generalQuestions');
            axiosRequest.then((response) => {

                commit('setGeneralQuestionsData', response.data.data.GENERAL_QUESTIONS);
                if (typeof response.data.data !== "undefined"
                    && typeof response.data.data.GENERAL_QUESTIONS !== "undefined"
                    && typeof response.data.data.GENERAL_QUESTIONS.countAnswered !== "undefined"
                    && typeof response.data.data.GENERAL_QUESTIONS.countTotal !== "undefined"
                    && response.data.data.GENERAL_QUESTIONS.countAnswered === response.data.data.GENERAL_QUESTIONS.countTotal) {
                    commit("enableFooterBtnNext");
                }

                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    submitStartQuestionAnswer ({commit, dispatch}, data) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/provideAnswer', {
                questionCode: data.questionCode,
                answerCode: data.newProvidedAnswerCode
            });
            axiosRequest.then((response) => {
                dispatch("updateAssessmentStartQuestionsData", response.data);
                dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });

                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    },

    submitGeneralQuestionAnswer ({commit, dispatch}, data) {
        let promise = new Promise((resolve, reject) => {
            let axiosRequest = axios.post(process.env.API_BASE_URL_PATHFINDER + '/assessment/provideAnswer', {
                questionCode: data.questionCode,
                answerCode: data.newProvidedAnswerCode
            });
            axiosRequest.then((response) => {

                dispatch("updateAssessmentGeneralQuestionsData", response.data);
                dispatch("AssessmentAlertsStore/refreshAlerts", response.data, { root: true });

                resolve(response);
            });
            axiosRequest.catch((error) => {
                console.log(error);
                reject(error);
            });
        });

        return promise;
    }

};


// ======================================================================
// Mutations
// ======================================================================

const mutations = {

    setStartQuestionsData (state, startQuestions) {
        state.startQuestionsData = startQuestions;
    },
    clearStartQuestionsData (state) {
        state.startQuestionsData = new Array();
    },

    setGeneralQuestionsData (state, generalQuestions) {
        state.generalQuestionsData = generalQuestions;
    },

    clearGeneralQuestionsData (state) {
        state.generalQuestionsData = [];
    },

    setPatientProfileData (state, newDataObj) {
        state.patientProfileData = newDataObj;
    },
    setPatientProfileComment (state, newVal) {
        state.patientProfileData.comment = newVal;
    },
    clearPatientProfileData (state) {
        state.patientProfileData = {};
    },
    clearPatientProfileComment (state) {
        state.patientProfileData.comment = "";
    },

    setMustShowFullQuestion (state, newVal) {
        state.mustShowFullQuestion = newVal;
    },

    setAssessmentToken (state, startQuestions) {
        state.assessmentToken = startQuestions;
    },
    clearAssessmentToken (state) {
        state.assessmentToken = "";
    },


    /**
     * Set answer id on a Start Question.
     * @param {Object} state
     * @param {Object} data - Expected properties: "questionCode", "answerCode"
     * @return {Void}
     */
    setStartQuestionAnswer (state, data) {
        let startQuestionIndex = state.startQuestionsData.questions.findIndex((startQuestion) => {
            return startQuestion.code == data.questionCode;
        });

        if (startQuestionIndex !== -1) {
            state.startQuestionsData.questions[startQuestionIndex].providedAnswer = data.answerCode
        }
    },

    enableFooterBtnNext (state) {
        state.footerBtnNext.isEnabled = true;
    },
    disableFooterBtnNext (state) {
        state.footerBtnNext.isEnabled = false;
    },

    setPatientProfileStatus (state, newVal) {
        state.patientProfileStatus = newVal;
    },
    setBackFromGeneral (state, newVal) {
        state.backFromGeneral = newVal
    },


    // ----------------------------------------------------------

    resetStore (state) {
        state.patientProfileData    = defaultState.patientProfileData;
        state.startQuestionsData    = defaultState.startQuestionsData;
        state.generalQuestionsData  = defaultState.generalQuestionsData;
        state.mustShowFullQuestion  = defaultState.mustShowFullQuestion;
        state.assessmentToken  = defaultState.assessmentToken;

        state.footerBtnNext = {
            isEnabled: defaultState.footerBtnNext.isEnabled
        };
        state.patientProfileStatus  = defaultState.patientProfileStatus;
        state.backFromGeneral = defaultState.backFromGeneral;
    }
};


// ======================================================================
// Exports
// ======================================================================

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/common/store/modules/pathfinder/standard-forms/PfAssessmentStartStore.js